export default __webpack_public_path__ + "04812055f2a852e6bde37645ab2e5134.png";